import CopyToClipboard from 'src/components/CopyToClipboard/CopyToClipboard';

export default CopyToClipboard;

export * from './CopyText';
